import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { AuthorizationService } from "../../services/authorization.service";
import { CustomCookieService } from '../../services/custom-cookie.service';

@Component({
  selector: 'app-logo-header',
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.scss']
})
export class LogoHeaderComponent implements OnInit {
  @Input() showMainLogo: boolean = false;
  @Input() showSimpleLogo: boolean = false;
  @Input() showSignOutButton: boolean = false;

  constructor(
    private authorizationService: AuthorizationService,
    private customCookieService: CustomCookieService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnChange(): void {
  }

  public onSignOut(): void {
    const uiClinetId = this.customCookieService.getData('ui-clinetId', true);
    const uiRedirectUrl = this.customCookieService.getData('ui-redirect_uri', true);
    this.authorizationService.signOut().subscribe({
      next: () => {
        this.router.navigate(['/main/home'], { queryParams: { id: uiClinetId, redirect_uri: uiRedirectUrl } });
      }
    })
  }

}
